import { createApp } from 'vue'
import ApplicationRoot from './App.vue'

createApp(ApplicationRoot).mount('#app') 